module.exports = __webpack_public_path__ + "img/bg_transform_room.93787e69.jpg";